class MobileMenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.navStack = [];
    this.#relocatePanels();
  }

  connectedCallback() {
    this.#relocatePanels();
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    const trigger = event.target.closest('[data-trigger]');
    const back = event.target.closest('[data-action="back"]');

    if (trigger) {
      const submenuId = trigger.getAttribute('data-trigger');
      const submenu = this.querySelector(`#${CSS.escape(submenuId)}`);
      if (submenu) this.openSubmenu(submenu);
      return;
    }

    if (back) this.closeSubmenu();
  };

  #relocatePanels() {
    const panels = this.querySelectorAll('.header__mobile-menu-submenu-panel');

    for (const panel of panels) {
      if (panel.parentElement === this) continue;

      panel.classList.remove('is-active', 'is-parent');
      this.append(panel);
    }
  }

  openSubmenu(submenu) {
    const currentNav = this.querySelector('.header__mobile-menu-nav.is-active');

    if (currentNav) {
      currentNav.classList.remove('is-active');
      currentNav.classList.add('is-parent');
      this.navStack.push(currentNav);
    }

    submenu.classList.add('is-active');
    this.scrollTo(0, 0);
  }

  closeSubmenu() {
    const currentNav = this.querySelector('.header__mobile-menu-nav.is-active');
    const previousNav = this.navStack.pop();

    currentNav?.classList.remove('is-active');

    if (!previousNav) return;

    previousNav.classList.remove('is-parent');
    previousNav.classList.add('is-active');
  }

  reset() {
    const panels = this.querySelectorAll('.header__mobile-menu-submenu-panel');

    for (const panel of panels) {
      panel.classList.remove('is-active', 'is-parent');
    }

    const mainNav = this.querySelector('.header__mobile-menu-nav[data-level="1"]');

    if (mainNav) {
      mainNav.classList.add('is-active');
      mainNav.classList.remove('is-parent');
    }

    this.navStack = [];
    this.scrollTo(0, 0);
  }
}

if (!customElements.get('mobile-menu-drawer')) {
  customElements.define('mobile-menu-drawer', MobileMenuDrawer);
}
